import { Container } from "aurelia-dependency-injection";
import { defineComponent } from "vue";
import { helpers, required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";

import { PatientService } from "../../../../../../services/patient.service";
import { ITypeaheadOptions } from "../../../../../../resources-vue/vue-interfaces/i-typeahead";
import { FamilyHealthHistoryModel } from "../../../../../../models/pal-health-history/family-health-history-model";
import { PatientRelations } from "../../../../../../models/pal-health-history/patient-relations";
import { ApplicationEnum } from "../../../../../../enums/ApplicationEnum";

import FormSection from "../../../../../../resources-vue/vue-custom-elements/FormSection/FormSection.vue";
import TypeaheadInput from "../../../../../../resources-vue/vue-custom-elements/TypeaheadInput/TypeaheadInput.vue";

export default defineComponent({
    components: {
        FormSection,
        TypeaheadInput
    },

    props: {
        familyHealthHistory: {
            type: FamilyHealthHistoryModel,
            default: new FamilyHealthHistoryModel()
        },
        isEdit: {
            type: Boolean,
            default: false
        },
        isSaveInProgress: {
            type: Boolean,
            default: false
        },
        relationStatusEnum: {
            type: Array,
            default: []
        },
        patientRelationshipEnum: {
            type: Array,
            default: []
        },
        application: {
            type: Number
        }
    },

    validations() {
        return {
            familyHealthHistory: {
                Condition: { required },
                PatientRelations: this.familyHealthHistory.PatientRelations.map(() => ({
                    RelationshipToPatient: { required }
                }))
            }
        };
    },

    data() {
        return {
            _patientsService: null as PatientService,
            selectedRelationship: [] as number[],
            relationshipOptions: [] as ITypeaheadOptions[],
            typeaheadInstance: TypeaheadInput,
            selectedHealthCondition: null,
            v$: useVuelidate()
        };
    },

    watch: {
        selectedHealthCondition() {
            this.selectedHealthConditionChanged();
        }
    },

    created() {
        this._patientsService = Container.instance.get(PatientService);
    },

    mounted() {
        if (this.familyHealthHistory.ConditionCode) {
            this.selectedHealthCondition = {
                name: this.familyHealthHistory.Condition,
                value: this.familyHealthHistory.ConditionCode
            };
        } else {
            this.selectedHealthCondition = null;
        }
    },

    methods: {
        addRelationship() {
            let newRelation = new PatientRelations();
            this.familyHealthHistory.PatientRelations.push(newRelation);
        },
        async getHealthCondtionsList(filter: string, limit: number) {
            const query = { term: filter, application: ApplicationEnum.AxxessPalliative };
            let healthConditions = await this._patientsService.getHealthCondition(query);
            if (healthConditions?.data.length) {
                return healthConditions.data.map((condition) => ({
                    name: condition.Term,
                    value: condition.ConceptId
                }));
            }
            return [];
        },

        selectedHealthConditionChanged() {
            if (!this.selectedHealthCondition) {
                this.familyHealthHistory.Condition = "";
                this.familyHealthHistory.ConditionCode = "";
                return;
            }
            this.familyHealthHistory.Condition = this.selectedHealthCondition.name;
            this.familyHealthHistory.ConditionCode = this.selectedHealthCondition.value;
        },

        handleValueChange(newValue: any) {
            this.selectedHealthCondition = newValue;
            this.selectedHealthConditionChanged();
        },

        removeRelationship(idx: number) {
            this.familyHealthHistory.PatientRelations.splice(idx, 1);
        }
    }
});
